import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import colControl from '@/components/colControl/colControl';
import { getAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import moment, { months } from 'moment';
import waterLineChart from '@/components/biChart/waterLineChart';
import yearRange from '@/components/date/yearRange';
import weekRange from '@/components/date/weekRange';
export default {
  name: 'lineAnalysis',
  mixins: [GetSiteIdMixin],
  components: {
    waterLineChart: waterLineChart,
    yearRange: yearRange,
    weekRange: weekRange,
    colControl: colControl
  },
  data: function data() {
    return {
      colOptions: [],
      initNum: 0,
      reportType: '11',
      limitSelectDate: {},
      value: [],
      stime: '',
      etime: '',
      quantum: '',
      dateFormat: 'YYYY-MM-DD',
      chartBoxHeight: '604px',
      tableData: [],
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      powerList: [],
      showSite: true,
      siteId1: ''
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'week'),
      max: moment().endOf('day')
    };
    this.value[0] = this.limitSelectDate.min;
    this.value[1] = this.limitSelectDate.max;
    console.log(this.value);
    this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
    this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
  },
  props: ['showSiteTree', 'siteId', 'selectType'],
  watch: {
    siteId: {
      handler: function handler(value) {
        if (value) {
          this.siteId1 = value;
        } else {
          this.siteId1 = window.sessionStorage.getItem("siteId");
        }
      },
      deep: true,
      immediate: true
    },
    showSiteTree: {
      handler: function handler(value) {
        if (value === false) {
          this.showSite = false;
        }
      },
      deep: true,
      immediate: true
    },
    currentSiteId: function currentSiteId(value) {}
  },
  methods: {
    onChange: function onChange() {
      var selectedDatas = JSON.parse(JSON.stringify(this.$refs.charts.selectedData));
      var data = {
        seriesData: [],
        xData: selectedDatas.xData,
        legendData: []
      };
      this.$refs.colControl.selectCol.forEach(function (item) {
        selectedDatas.items.forEach(function (item1, index1) {
          if (item == item1.code) {
            data.seriesData.push(selectedDatas.seriesData[index1]);
            data.legendData.push(selectedDatas.legendData[index1]);
          }
        });
      });
      console.log('this.$refs.colControl.selectCol', this.$refs.colControl.selectCol);
      console.log('selectedData', this.$refs.charts.selectedData);
      console.log('data', data);
      this.$refs.charts.changeChartInit(data);
    },
    openCol: function openCol(index) {
      if (typeof index == 'number') {
        this.$refs.colControl[0].visible = true;
      } else {
        this.$refs.colControl.visible = true;
      }
    },
    moment: moment,
    searchChart: function searchChart() {
      this.initNum++;
    },
    onMonthRangeChange: function onMonthRangeChange(value) {
      this.value = value;
      this.stime = moment(value[0]).format('YYYY-MM');
      this.etime = moment(value[1]).format('YYYY-MM');
    },
    handleRangeChange: function handleRangeChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1]; // console.log('实时数据/日数据', dateString)
    },
    dataTypeChange: function dataTypeChange(e) {
      this.reportType = e.target.value;

      if (e.target.value == '14') {
        this.limitSelectDate = {
          min: moment().startOf('day').subtract(1, 'month'),
          max: moment().endOf('day')
        };
        this.value[0] = this.limitSelectDate.min;
        this.value[1] = this.limitSelectDate.max;
        this.stime = this.limitSelectDate.min.format('YYYY-MM');
        this.etime = this.limitSelectDate.max.format('YYYY-MM');
      } else if (e.target.value == '11' || e.target.value == '12') {
        this.value[0] = this.limitSelectDate.min;
        this.value[1] = this.limitSelectDate.max;
        this.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
      }
    },
    getWeek: function getWeek(dt) {
      var d1 = new Date(dt);
      var d2 = new Date(dt);
      d2.setMonth(0);
      d2.setDate(1);
      var rq = d1 - d2;
      var days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      var num = Math.ceil(days / 7);
      return num + 1;
    },
    onWeekRangeChange: function onWeekRangeChange(value) {
      console.log('周区间', value);
      this.stime = value[0];
      this.etime = value[1];
    },
    onYearRangeChange: function onYearRangeChange(value) {
      console.log('季/年区间', value);
      this.stime = value[0] + '';
      this.etime = value[1] + '';
    },
    onallChange: function onallChange(date, dateString) {
      this.stime = dateString[0];
      this.etime = dateString[1];
      this.value = [moment(dateString[0]), moment(dateString[1])];
      console.log('实时数据/日数据', dateString);
    }
  }
};